/**
 * Registro de tipos de bloque de la app web (los 6 base). Único punto de
 * verdad para render/corrección: el player y la re-corrección local usan la
 * MISMA instancia. Añadir un tipo = registrar su plugin aquí (el motor no
 * cambia) — invariante de extensibilidad de `learning-blocks`.
 */
import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import { defaultRegistry } from "@space/shared";

export const blockRegistry = defaultRegistry();

/** Metadatos de UI de cada tipo de bloque (para el editor de autoría).
 * `label`/`hint` son MessageDescriptor: los consumidores renderizan con `t()`. */
export interface BlockKindMeta {
  kind: string;
  label: MessageDescriptor;
  hint: MessageDescriptor;
}

export const BLOCK_KINDS: BlockKindMeta[] = [
  { kind: "quiz", label: msg`Quiz`, hint: msg`Single or multiple choice` },
  { kind: "flashcard", label: msg`Flashcard`, hint: msg`Front / back` },
  { kind: "fill-blank", label: msg`Fill in the blanks`, hint: msg`Fill the gaps` },
  { kind: "match", label: msg`Match`, hint: msg`Match the pairs` },
  { kind: "code", label: msg`Code`, hint: msg`Write or complete code` },
  { kind: "listen-type", label: msg`Listen and type`, hint: msg`Transcribe the audio` },
  // MEDIA-F3F: bloque `video` (VOD)
  { kind: "video", label: msg`Video`, hint: msg`Play a video (VOD)` },
];

/** Plantilla de `def` por defecto para un tipo nuevo (autoría). */
export function defaultDefFor(kind: string): unknown {
  switch (kind) {
    case "quiz": {
      return {
        prompt: "",
        options: [
          { id: "a", text: "" },
          { id: "b", text: "" },
        ],
        correct: ["a"],
        multiple: false,
      };
    }
    case "flashcard": {
      return { front: "", back: "" };
    }
    case "fill-blank": {
      return { text: "", blanks: [{ id: "1", answers: [""] }] };
    }
    case "match": {
      return {
        pairs: [
          { left: "", right: "" },
          { left: "", right: "" },
        ],
      };
    }
    case "code": {
      return { prompt: "", language: "text", checks: [{ kind: "contains", value: "" }] };
    }
    case "listen-type": {
      return { audioRef: "", transcript: "" };
    }
    // MEDIA-F3F: bloque `video`
    case "video": {
      return { videoAssetId: "", minWatchPct: 0.9 };
    }
    default: {
      return {};
    }
  }
}
